import { fetchApi } from '@/config/axiosSetting';
import { GetCulpritPreviousCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPreviousCorrectiveImages/getCulpritPreviousCorrectiveImages.type';
import { GetPreviousCorrectiveImageResponse } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';

export const getCulpritPreviousCorrectiveImagesFunction = (
  params: GetCulpritPreviousCorrectiveImagesType,
): Promise<GetPreviousCorrectiveImageResponse> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/corrective/request/list/`,
  );
};
